"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _clsx2 = _interopRequireDefault(require("clsx"));
var _styles = require("@material-ui/core/styles");
var _CarouselNavButton = _interopRequireWildcard(require("./CarouselNavButton"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
var __jsx = _react.default.createElement;
function getPageIndices(totalSlides, slidesPerPage) {
  var arr = [];
  for (var i = 0; i < totalSlides; i += slidesPerPage) {
    arr.push(i);
  }
  return arr;
}
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    paginationList: (0, _defineProperty2.default)({
      display: 'none'
    }, theme.breakpoints.up('md'), {
      display: 'flex',
      margin: '0 0 30px',
      padding: 0,
      listStyleType: 'none'
    }),
    numeralPagination: (0, _defineProperty2.default)({
      display: 'flex',
      alignItems: 'center',
      '& > * + *': {
        marginLeft: theme.spacing(3)
      }
    }, theme.breakpoints.up('md'), {
      display: 'none'
    }),
    paginationButton: {
      cursor: 'pointer',
      background: 'transparent',
      fill: 'white',
      opacity: 0.5,
      padding: '1px 6px',
      border: 'none',
      lineHeight: '0',
      borderRadius: '50px',
      '&:focus': {
        outline: 'none !important'
      }
    },
    isActivePaginationButton: {
      opacity: 1,
      padding: '4px',
      border: "2px solid ".concat(theme.palette.common.white)
    },
    homePaginationButton: {
      margin: '0 3px',
      opacity: 1,
      padding: '3px',
      border: "2px solid ".concat(theme.palette.primary.main)
    },
    isActiveHomePaginationButton: {
      fill: theme.palette.primary.main,
      borderColor: theme.palette.common.white
    }
  };
});
var CarouselPagination = function CarouselPagination(_ref) {
  var onPaginationItemClick = _ref.onPaginationItemClick,
    currentSlide = _ref.currentSlide,
    slideCount = _ref.slideCount,
    slidesPerPage = _ref.slidesPerPage,
    isHomepage = _ref.isHomepage;
  var classes = useStyles();
  var pageIndices = getPageIndices(slideCount, slidesPerPage);
  var isFirstSlide = currentSlide === 0;
  var isLastSlide = currentSlide + slidesPerPage === slideCount || slideCount < slidesPerPage;
  var dotSize = isHomepage ? 8 : 6;
  var circleSize = isHomepage ? 4 : 3;
  return __jsx(_react.default.Fragment, null, __jsx("div", {
    className: classes.numeralPagination
  }, __jsx(_CarouselNavButton.default, {
    isHomepage: isHomepage,
    direction: _CarouselNavButton.CarouselNavButtonDirection.Previous,
    isInsideContainer: true,
    isDisabled: isFirstSlide,
    onClick: function onClick() {
      return onPaginationItemClick(currentSlide - 1);
    },
    isRound: false,
    isPagination: true
  }), __jsx("div", null, currentSlide + 1, " of ", slideCount), __jsx(_CarouselNavButton.default, {
    isHomepage: isHomepage,
    direction: _CarouselNavButton.CarouselNavButtonDirection.Next,
    isInsideContainer: true,
    isDisabled: isLastSlide,
    onClick: function onClick() {
      return onPaginationItemClick(currentSlide + 1);
    },
    isRound: false,
    isPagination: true
  })), __jsx("ul", {
    className: classes.paginationList
  }, pageIndices.map(function (index) {
    var _clsx;
    return __jsx("li", {
      key: index
    }, __jsx("button", {
      className: (0, _clsx2.default)((_clsx = {}, (0, _defineProperty2.default)(_clsx, classes.paginationButton, true), (0, _defineProperty2.default)(_clsx, classes.isActivePaginationButton, currentSlide === index), (0, _defineProperty2.default)(_clsx, classes.homePaginationButton, isHomepage), (0, _defineProperty2.default)(_clsx, classes.isActiveHomePaginationButton, isHomepage && currentSlide === index), _clsx)),
      onClick: function onClick() {
        return onPaginationItemClick(index);
      }
    }, __jsx("svg", {
      width: dotSize,
      height: dotSize
    }, __jsx("circle", {
      cx: dotSize / 2,
      cy: dotSize / 2,
      r: circleSize
    }))));
  })));
};
var _default = CarouselPagination;
exports.default = _default;